<template>
  <v-container fluid class="ov">
    <!-- Header -->
    <div class="ov-header">
      <div>
        <div class="ov-title">
          👋 Immigration Overview — สรุปสถานะงานทั้งหมด
        </div>
        <!-- <div class="ov-sub">{{ todayText }} · ข้อมูล ณ วันนี้</div> -->
      </div>
      <!-- <div class="text-right">
        <div class="ov-pending">{{ summary.pending }}</div>
        <div class="ov-sub">รายการรอดำเนินการ</div>
      </div> -->
    </div>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

    <!-- Stat cards -->
    <v-row dense class="mb-2">
      <v-col v-for="c in statCards" :key="c.key" cols="6" sm="4" md="2">
        <div
          class="ov-card ov-stat"
          :style="{ borderTopColor: c.color, cursor: c.to ? 'pointer' : 'default' }"
          @click="c.to && $router.push(c.to)"
        >
          <div class="ov-stat-label">
            <span class="dot" :style="{ background: c.color }"></span>{{ c.label }}
          </div>
          <div class="ov-stat-value" :style="{ color: c.color }">{{ summary[c.key] }}</div>
          <div class="ov-stat-sub">{{ c.sub }}</div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <!-- Urgent -->
      <v-col cols="12" md="6">
        <div class="ov-section">🚨 URGENT — ต้องดำเนินการด่วน</div>
        <div v-if="!urgent.length && !loading" class="ov-card ov-empty">ไม่มีรายการเร่งด่วน</div>
<div
  v-for="u in urgentPaged"
  :key="u.id"
  class="ov-urgent"
  :class="level(u.days_left)"
  @click="$router.push(`/immigration-docket-edit/${u.id}`)"
>
  <v-icon class="mr-3" :color="levelColor(u.days_left)">{{ deadlineIcon(u.deadline_type) }}</v-icon>
  <div class="flex-grow-1">
    <div class="ov-urgent-title">{{ u.applicant }} — {{ deadlineLabel(u) }}</div>
    <div class="ov-urgent-sub">{{ u.file_no_display }} · {{ u.client_name }}</div>
    <div class="ov-urgent-cw">
      Case Worker: {{ u.case_worker || "-" }}
      <span v-if="u.days_left >= 0"> · Due: {{ fmtDate(u.deadline) }}</span>
    </div>
  </div>
  <div class="text-right">
    <span class="ov-badge" :class="level(u.days_left)">
      {{ u.days_left < 0 ? "OVERDUE" : u.days_left === 0 ? "TODAY" : `DUE IN` }}
    </span>
    <div class="ov-days" :style="{ color: levelColor(u.days_left) }">
      {{ Math.abs(u.days_left) }}d
    </div>
  </div>
</div>
<div v-if="urgentPageCount > 1" class="text-center">
  <v-pagination v-model="urgentPage" :length="urgentPageCount" total-visible="7" />
</div>
      </v-col>

      <v-col cols="12" md="6">
        <!-- Work type summary -->
        <div class="ov-section">📊 สรุปงานตาม WORK TYPE</div>
    <div class="ov-card pa-3 mb-6">
  <table class="ov-table">
    <thead>
      <tr>
        <th class="text-left">WORK TYPE</th>
        <th>ONGOING</th>
        <th>COMPLETE</th>
        <th>OVERDUE</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="w in workTypePaged" :key="w.work_type">
        <td class="text-left">{{ workTypeLabel(w.work_type) }}</td>
        <td>{{ w.ongoing }}</td>
        <td>{{ w.complete }}</td>
        <td>
          <span v-if="w.overdue" class="ov-badge overdue">{{ w.overdue }}</span>
          <span v-else>0</span>
        </td>
      </tr>
      <tr v-if="!workTypeSummary.length">
        <td colspan="4" class="ov-empty">ไม่มีข้อมูล</td>
      </tr>
    </tbody>
  </table>
  <div v-if="workTypePageCount > 1" class="text-center pt-2">
    <v-pagination v-model="workTypePage" :length="workTypePageCount" total-visible="7" />
  </div>
</div>

        <!-- Expiring -->
        <div class="ov-section">📅 VISA / WP / LTR ที่ใกล้หมดอายุ (30 วัน)</div>
      <div class="ov-card">
  <v-data-table
    :headers="expiringHeaders"
    :items="expiringRows"
    item-key="key"
    :items-per-page="5"
    :page.sync="expiringPage"
    @page-count="expiringPageCount = $event"
    hide-default-footer
    dense
    no-data-text="ไม่มีรายการใกล้หมดอายุ"
  >
    <template v-slot:item.file_no_display="{ item }">
      <a class="ov-link" @click="$router.push(`/immigration-docket-edit/${item.id}`)">
        {{ item.file_no_display }}
      </a>
    </template>
    <template v-slot:item.expiry_date="{ item }">
      <span class="ov-badge" :class="item.days_left <= 7 ? 'overdue' : 'warn'">
        {{ item.type }} {{ fmtDate(item.expiry_date, true) }}
      </span>
    </template>
  </v-data-table>
  <div v-if="expiringPageCount > 1" class="text-center py-2">
    <v-pagination v-model="expiringPage" :length="expiringPageCount" total-visible="7" />
  </div>
</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";

const WORK_TYPE_LABELS = {
  "visa-renewal": "Visa Renewal",
  "visa-cancel": "Visa Cancellation",
  "wp-new": "New Work Permit",
  "wp-renewal": "Work Permit Renewal",
  "wp-cancel": "Work Permit Cancellation",
  "wp-urgent": "Urgent Work Permit Extension",
  "vwp-renewal": "Visa & Work Permit Renewal",
  "ltr-new": "New LTR",
  "ltr-renewal": "LTR Renewal",
  "ltr-cancel": "LTR Cancellation",
  pcc: "Police Clearance Certificate",
  legal: "Legalization",
  notarial: "Notarial Services",
  "90day": "90-Day Report",
  annual: "Annual Report",
  toe: "Transfer of Endorsement",
  tax: "Personal Income Tax Filing",
  other: "Others",
};
const TH_DAYS = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"];
const TH_MONTHS = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];

export default {
  name: "ImOverview",
  data() {
    return {
      workTypePage: 1,
       urgentPage: 1,
       expiringPage: 1,
      expiringPageCount: 0,
      expiringHeaders: [
        { text: "File No.", value: "file_no_display" },
        { text: "Applicant", value: "applicant" },
        { text: "Expiry", value: "expiry_date", align: "end" },
      ],
      loading: false,
      today: null,
      summary: {
        pending: 0, overdue: 0, due_today: 0, due_7: 0,
        ongoing: 0, complete: 0, active_matters: 0,
      },
      urgent: [],
      workTypeSummary: [],
      expiring: [],
      statCards: [
        { key: "overdue", label: "Overdue", sub: "เกินกำหนดแล้ว", color: "#dc2626" },
        { key: "due_today", label: "Due Today", sub: "ครบกำหนดวันนี้", color: "#ea580c" },
        { key: "due_7", label: "Due ≤ 7 วัน", sub: "กำลังจะถึงกำหนด", color: "#d97706" },
        { key: "ongoing", label: "Ongoing", sub: "ดำเนินการอยู่", color: "#2563eb",
          to: { path: "/immigration-docket", query: { status: "ongoing" } } },
        { key: "complete", label: "Complete", sub: "เสร็จสิ้น", color: "#16a34a",
          to: { path: "/immigration-docket", query: { status: "complete" } } },
        { key: "active_matters", label: "Active Matters", sub: "แฟ้มที่ Active", color: "#9ca3af",
          to: { path: "/immigration-matter", query: { status: "active" }} },
      ],
    };
  },
  computed: {
    workTypePageCount() {
      return Math.ceil(this.workTypeSummary.length / 5);
    },
    workTypePaged() {
      const start = (this.workTypePage - 1) * 5;
      return this.workTypeSummary.slice(start, start + 5);
    },
     urgentPageCount() {
      return Math.ceil(this.urgent.length / 6);
    },
    urgentPaged() {
      const start = (this.urgentPage - 1) * 6;
      return this.urgent.slice(start, start + 6);
    },
    todayText() {
      if (!this.today) return "";
      const [y, m, d] = this.today.split("-").map(Number);
      const dt = new Date(y, m - 1, d);
      return `วัน${TH_DAYS[dt.getDay()]}ที่ ${d} ${TH_MONTHS[m - 1]} ${y}`;
    },
    expiringRows() {
      return this.expiring.map((e) => ({ ...e, key: `${e.id}-${e.type}` }));
    },
  },
  async mounted() {
    this.$store.state.navMenu = true;
    if (!(localStorage.getItem(server.USER_ID) && api.isLoggedIn())) {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
      return;
    }
    await this.loadData();
    this.$hideLoader();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const { data } = await api.getOverviewim_docket(
          localStorage.getItem(server.COMPANYID),
        );
        this.today = data.today;
        this.summary = data.summary;
        this.urgent = data.urgent;
        this.workTypeSummary = data.work_type_summary;
        this.expiring = data.expiring;
      } catch (error) {
        console.error("Error loading overview:", error);
      } finally {
        this.loading = false;
      }
    },
    workTypeLabel(v) {
      return WORK_TYPE_LABELS[v] || v;
    },
    deadlineLabel(u) {
      return (
        { visa: "Visa Expiry", wp: "Work Permit Expiry", ltr: "LTR Expiry" }[u.deadline_type] ||
        this.workTypeLabel(u.work_type)
      );
    },
    deadlineIcon(type) {
      return (
        { visa: "mdi-passport", wp: "mdi-card-account-details", ltr: "mdi-card-account-details-star" }[type] ||
        "mdi-calendar-alert"
      );
    },
    level(days) {
      if (days < 0) return "overdue";
      if (days <= 7) return "warn";
      if (days <= 15) return "soon";
      return "";
    },
    levelColor(days) {
      return { overdue: "#dc2626", warn: "#d97706", info: "#2563eb", soon: "#2563eb" }[this.level(days)];
    },
    fmtDate(s, short = false) {
      if (!s) return "-";
      const [y, m, d] = s.split("-");
      return short ? `${d}/${m}` : `${d}/${m}/${y}`;
    },
  },
};
</script>

<style scoped>
.ov { background: #f3f4f6; min-height: 100%; }
.ov-header {
  display: flex; justify-content: space-between; align-items: center;
  background: linear-gradient(90deg, #1e3a5f 0%, #1e5f8a 50%, #2563eb 100%);
  color: #fff; border-radius: 12px; padding: 22px 26px; margin-bottom: 18px;
}
.ov-title { font-size: 18px; font-weight: 700; }
.ov-sub { font-size: 12px; opacity: 0.85; }
.ov-pending { font-size: 30px; font-weight: 800; line-height: 1; }
.ov-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; }
.ov-stat { border-top: 4px solid; text-align: center; padding: 14px 8px; height: 100%; }
.ov-stat-label { font-size: 12px; color: #4b5563; }
.ov-stat-value { font-size: 28px; font-weight: 800; line-height: 1.3; }
.ov-stat-sub { font-size: 10px; color: #9ca3af; }
.dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; margin-right: 5px; }
.ov-section { font-size: 13px; font-weight: 700; color: #374151; margin: 8px 0 10px; letter-spacing: 0.3px; }
.ov-urgent {
  display: flex; align-items: center; border: 1px solid; border-radius: 8px;
  padding: 10px 14px; margin-bottom: 8px; cursor: pointer;
}
.ov-urgent.overdue { background: #fef2f2; border-color: #fca5a5; }
.ov-urgent.warn { background: #fffbeb; border-color: #fcd34d; }
.ov-urgent.info { background: #eff6ff; border-color: #93c5fd; }
.ov-urgent.soon { background: #eff6ff; border-color: #93c5fd; }
.ov-urgent-title { font-size: 13px; font-weight: 700; color: #111827; }
.ov-urgent-sub { font-size: 11px; color: #4b5563; }
.ov-urgent-cw { font-size: 10px; color: #9ca3af; }
.ov-days { font-size: 20px; font-weight: 800; }
.ov-badge { display: inline-block; font-size: 10px; font-weight: 700; padding: 2px 7px; border-radius: 4px; }
.ov-badge.overdue { background: #fee2e2; color: #b91c1c; }
.ov-badge.warn { background: #fef3c7; color: #b45309; }
.ov-badge.info { background: #dbeafe; color: #1d4ed8; }
.ov-badge.soon { background: #dbeafe; color: #1d4ed8; }
.ov-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.ov-table th {
  background: #f9fafb; color: #6b7280; font-size: 11px; font-weight: 600;
  padding: 10px; text-align: center; border-bottom: 1px solid #e5e7eb;
}
.ov-table td { padding: 10px; text-align: center; border-bottom: 1px solid #f3f4f6; color: #374151; }
.ov-table .text-left { text-align: left; }
.ov-exp { display: flex; align-items: center; padding: 10px 14px; border-bottom: 1px solid #f3f4f6; font-size: 12px; }
.ov-exp:last-child { border-bottom: none; }
.ov-link { color: #2563eb; font-weight: 500; margin-right: 10px; cursor: pointer; }
.ov-exp-name { color: #4b5563; }
.ov-empty { color: #9ca3af; font-size: 12px; text-align: center; padding: 16px; }
</style>